<template>
  <ExActionsPopUp
    :value="show"
    headline="Delete Job Family"
    :htmlInfo="info"
    :destructive="true"
    actionLabel="Delete"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onDelete')"
    @input="$emit('onClose')"
    data-testid="delete-job-family-popup"
    :applyBorderClass="true"
    :backgroundPatternBottomRight="true"
    :width="450"
  />
</template>

<script>
export default {
  name: "DeleteJobFamilyDialog",
};
</script>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";
import { deleteInfoHtml } from "./deleteJobFamilyDialog.js";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
});

defineEmits(["onDelete", "onClose"]);

const info = computed(() => deleteInfoHtml(props.name));
</script>
